<div class="breadcrumb-wrapper">
  <div class="path-value-wrapper">
    <a class="path-value" href="#/"><mat-icon>home</mat-icon><span>All Items</span></a>
  </div>
  @for (item of items(); track $index) {
  <div class="path-value-wrapper">
    <mat-icon>chevron_right</mat-icon>
    <a class="path-value" [ngClass]="{'selected' : $index === items().length -1}"
      href="{{ item.route }}">{{item.title}}</a>
  </div>
  }
</div>